The primary position profile for this candidate profile.

- For candidate applications, this is the job ad that the candidate applied to.
- For purchased profiles, this is the unposted position profile that the purchase is scoped to.
- For uploaded candidate profiles, this is always `null`.
- For Apply with SEEK candidate profiles, this is always `null`.
